export default "__VITE_ASSET__Diq9OxEQ__"